import $ from "jquery";
import counterUp from "counterup2";
import 'slick-carousel';
import 'jquery-nice-select';

export default {
  init() {
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (scroll >= 95) {
        $("body").addClass("fixed");
      } else {
        $("body").removeClass("fixed");
      }
      if($(window).width() < 1198 )
      {
        $('#menu-menu-idroexpert-com.navbar-nav').addClass('sm-collapsible');
        $('#menu-menu-idroexpert-com.dropdown-toggle').addClass('nav-link')
        $('a.dropdown-toggle').click(function(){
          var _this = $(this);
          window.setTimeout(function(){
            _this.closest('ul.dropdown-menu').addClass('show');
          },1)
        })
      }else{
        $('#menu-menu-idroexpert-com.navbar-nav').removeClass('sm-collapsible');
        $('#menu-menu-idroexpert-com.dropdown-toggle').removeClass('nav-link')
      }
    });
  },
  finalize() {
    if ($('.statvalue').length > 0) {
      [].forEach.call(
          document.querySelectorAll('.statvalue'),
          function (el) {
            counterUp( el, {
              duration: 2000
            } )
          }
      );
    }
    $('.backTop a').click(function(){
      $('html, body').animate({
        scrollTop: 0
      }, 1000);
    });
    if ($('.hero-img-slider').length > 0) {

      $('.hero-text-slide, .hero-img-slider').on('init', function () {
        $('.hero-text-slide, .hero-img-slider').find('.slick-current').removeClass('slick-active').addClass('reset-animation');
        setTimeout(function () {
          $('.hero-text-slide, .hero-img-slider').find('.slick-current').removeClass('reset-animation').addClass('slick-active');
        }, 500);
      });


      jQuery('.hero-img-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        centerMode: false,
        autoplay: true,
        autoplaySpeed: 7000,
        fade: true,
        speed: 900,
        infinite: true,
        cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
        touchThreshold: 100,
        responsive: [
          {
            breakpoint: 768,
            settings: {}
          }
        ]
      });


      $('.hero-text-slide').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        arrows: false,
        dots: false
      });

    }

    var scroll = $(window).scrollTop();
    if (scroll >= 95) {
      $("body").addClass("fixed");
    } else {
      $("body").removeClass("fixed");
    }


    $('.pb-box').click(function(){
      if($(this).find('.pb-link').length > 0)
      {
        $(this).find('.pb-link')[0].click();
      }
    });

    $('.navbar-toggler').on('click', function () {
      $('body').toggleClass('nav-open');
    })

    $('select:not(.ignore)').niceSelect();
    if($(window).width() < 1198 )
    {
      $('#menu-menu-idroexpert-com.navbar-nav').addClass('sm-collapsible');
      $('#menu-menu-idroexpert-com.dropdown-toggle').addClass('nav-link')
      $('a.dropdown-toggle').click(function(){
        var _this = $(this);
        window.setTimeout(function(){
          _this.closest('ul.dropdown-menu').addClass('show');
        },1)
      })
    }else{
      $('#menu-menu-idroexpert-com.navbar-nav').removeClass('sm-collapsible');
      $('#menu-menu-idroexpert-com.dropdown-toggle').removeClass('nav-link')
    }

    if ($('.form-check').length > 0) {
      jQuery('body').on('click', '.form-check-input', function () {
          jQuery(this).closest('.form-check-label').toggleClass('checked-label');
      });
    }
    if($('.wpcf7-spinner').length > 0)
    {
      $('.wpcf7-spinner').each(function (){
        $(this).closest('form').append($(this));
      })
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js